function initMachineryCards(){
    const cardBanners = $(".card__banner__wrapper");

    cardBanners.find(".info__action span").on("click", function () {
        const clickedIndex = $(this).parents(".card__banner__wrapper").index(".card__banner__wrapper");        

        if (!cardBanners.eq(clickedIndex).hasClass("open")) {

            $(cardBanners, "open").find(".info__dropdown").stop().slideUp();
            $(cardBanners, "open").removeClass("open");

            cardBanners.eq(clickedIndex).find(".info__dropdown").stop().slideDown();
            cardBanners.eq(clickedIndex).addClass("open");

        } else {
            $(cardBanners, "open").find(".info__dropdown").stop().slideUp();
            $(cardBanners, "open").removeClass("open");
        }
    })

    var $usedImgCarousel = $('.used-img-carousel');

    $usedImgCarousel.flickity({
        wrapAround : false,
        pageDots : false,
        prevNextButtons : true,
        imagesLoaded: true,
        groupCells: true,
        contain: false,
        draggable: true,
    })

    MicroModal.init({
        onShow: () => $usedImgCarousel.flickity('resize'),
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
    })
}

initMachineryCards();